module.exports = __webpack_public_path__ + "static/media/UdonSwapLogo.91e8a0f9.png";